(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.SelectZonesController = (function(superClass) {
    extend(SelectZonesController, superClass);

    function SelectZonesController(scope, transitions, pgis, validation, zones) {
      this.scope = scope;
      this.transitions = transitions;
      this.pgis = pgis;
      this.validation = validation;
      this.zones = zones;
      this.buttonDisabled = bind(this.buttonDisabled, this);
      this.disableZoneSteps = bind(this.disableZoneSteps, this);
      this.enableZoneSteps = bind(this.enableZoneSteps, this);
      this.toggleZone = bind(this.toggleZone, this);
      this.validate = bind(this.validate, this);
      this.cleanup = bind(this.cleanup, this);
      if (this.validation.canContinue()) {
        this.scope.validate = this.validate;
        this.validation.setStepScope(this.scope);
        this.scope.field_data = this.validation.getFieldData();
        this.scope.toggleZone = this.toggleZone;
        this.scope.buttonDisabled = this.buttonDisabled;
        if (this.scope.field_data.year != null) {
          this.scope.field_data.editing = null;
        }
        this.validation.setBackButtonDisable(this.scope.field_data, 'zone-add');
        this.transitionStart = this.transitions.onStart({}, (function(_this) {
          return function($transition) {
            if (!_.startsWith($transition.to().name, 'grower.fields-define')) {
              _this.validation.clearLayers();
              return _this.validation.settings = {};
            }
          };
        })(this));
        this.scope.$on('$destroy', (function(_this) {
          return function() {
            return _this.transitionStart();
          };
        })(this));
      }
    }

    SelectZonesController.prototype.cleanup = function() {
      return delete this.scope.field_data;
    };

    SelectZonesController.prototype.validate = function() {
      this.validation.setFieldData(this.scope.field_data);
      return true;
    };

    SelectZonesController.prototype.toggleZone = function(zone) {
      zone.enabled = !zone.enabled;
      if (zone.enabled) {
        return this.enableZoneSteps(zone);
      } else {
        return this.disableZoneSteps(zone);
      }
    };

    SelectZonesController.prototype.enableZoneSteps = function(zone) {
      var i, len, ref, results, step;
      ref = zone.child_steps;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        step = ref[i];
        results.push(this.scope.$parent.steps.enableStep(step));
      }
      return results;
    };

    SelectZonesController.prototype.disableZoneSteps = function(zone) {
      var i, len, ref, results, step;
      ref = zone.child_steps;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        step = ref[i];
        results.push(this.scope.$parent.steps.disableStep(step));
      }
      return results;
    };

    SelectZonesController.prototype.buttonDisabled = function(zone) {
      return zone.name === 'Previous Crop' && this.scope.field_data.zones['previous-crop'].has_existing;
    };

    return SelectZonesController;

  })(Controller);

}).call(this);
